<template>
  <v-container grid-list-sm text-xs-center>
    <v-layout column wrap>
      <!--<teacher-selector v-model="teacherId"></teacher-selector>-->
      <v-flex xs12>
        <bar-chart :chart-data="dataObject" :options="optionsObject" :width="400" :height="200"></bar-chart>
      </v-flex>
    </v-layout>
    <loading v-model="loading" :message="$t('common.LOADING')"></loading>
  </v-container>
</template>

<script>
  import {StatisticsResource} from '../../api/statistics'
  import Loading from '@/components/common/Loading'
  import TeacherSelector from '@/components/users/TeacherSelector'
  import BarChart from './BarChart'
  export default {
    name: 'QuestionnaireEvolution',
    props: ['teacherId'],
    components: {
      Loading,
      TeacherSelector,
      BarChart
    },
    data () {
      return {
        evolution: [],
        dataObject: null,
        optionsObject: {
          tooltips: {
            callbacks: {}
          },
          scales: {
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Intent de autoavaluació'
              }
            }],
            yAxes: [{
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: '% de items contestats'
              }
            }]
          }
        }
      }
    },
    watch: {
      'teacherId': function () {
        if (this.teacherId != null) {
          this.loading = true
          StatisticsResource().getEvolution({teacherId: this.teacherId}).then(response => {
            this.evolution = response.body
            this.updateChart()
            this.loading = false
          }, response => {
            console.log('Error in getStatistics: ')
            console.log(response)
            this.loading = false
          })
        }
      }
    },
    created () {

    },
    methods: {
      updateChart: function () {
        var redData = []
        var orangeData = []
        var greenData = []
        var labels = []
        this.evolution.forEach(e => {
          let total = e.red + e.orange + e.green
          labels.push(e.order)
          redData.push(e.red / total)
          orangeData.push(e.orange / total)
          greenData.push(e.green / total)
        })

        var stack = 1
        var redDataset = {
          label: 'red',
          data: redData,
          backgroundColor: '#f44336',
          borderColor: '#cd261e',
          stack: stack,
          borderWidth: 2
        }

        // console.log(stack)
        var orangeDataset = {
          label: 'orange',
          data: orangeData,
          backgroundColor: '#ff9800',
          borderColor: '#cd4300',
          stack: stack,
          borderWidth: 2
        }

        var greenDataset = {
          label: 'green',
          data: greenData,
          backgroundColor: '#46cd46',
          borderColor: '#4caf50',
          stack: stack,
          borderWidth: 2
        }

        this.dataObject = {
          labels: labels,
          datasets: [redDataset, orangeDataset, greenDataset]
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/results/QuestionnaireEvolution.vue